module.exports = __webpack_public_path__ + "logo_institut-665824448a4c065e662359c5dd4e9e3c.jpg";